module.exports = __webpack_public_path__ + "img/games-9.aa6b2f6a.jpg";